<template>
  <Modal :title="title" :active="active" @close="closeModal()">
    <ValidationObserver v-slot="{ invalid }">
      <div class="vx-row">
        <div class="vx-col w-full mt-4">
          <label class="label-text">Status da pré-análise</label>
          <vs-select
            v-model="form.mode"
            class="w-full mode-select"
            data-testid="inspection-pre-analysis-mode-select"
          >
            <vs-select-item
              v-for="option in modeOptions"
              :key="`inspection-pre-analysis-mode-${option.value}`"
              :value="option.value"
              :text="option.label"
            />
          </vs-select>
        </div>
        <div class="vx-col w-full mt-4">
          <ValidationProvider
            name="Nº de retentativas"
            :rules="retriesRules"
            immediate
            v-slot="{ errors }"
          >
            <label class="label-text"
              >Nº de retentativas que libera envio</label
            >
            <vs-input
              v-model="form.retriesToAllowSend"
              type="number"
              min="0"
              step="1"
              class="w-full"
              :danger="!!errors.length"
              data-testid="inspection-pre-analysis-retries-input"
            />
            <span v-show="!!errors.length" class="text-danger"
              >{{ errors[0] }}
            </span>
          </ValidationProvider>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            @click="save"
            type="gradient"
            color="primary"
            class="mt-5"
            :disabled="invalid"
            data-testid="inspection-pre-analysis-save"
          >
            Salvar
          </vs-button>
        </div>
      </div>
    </ValidationObserver>
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import {
  INSPECTION_PRE_ANALYSIS_MODES,
  INSPECTION_PRE_ANALYSIS_RULE_NAME,
} from '../../utils/constants';

export default {
  name: 'InspectionPreAnalysisModal',
  components: {
    ValidationProvider,
    ValidationObserver,
    Modal,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      title: INSPECTION_PRE_ANALYSIS_RULE_NAME,
      modeOptions: Object.values(INSPECTION_PRE_ANALYSIS_MODES),
      form: {
        mode: null,
        retriesToAllowSend: null,
      },
    };
  },
  computed: {
    retriesRules() {
      return this.form.mode === INSPECTION_PRE_ANALYSIS_MODES.ON.value
        ? 'required|integer|min_value:0'
        : 'integer|min_value:0';
    },
  },
  methods: {
    open() {
      if (this.config) {
        this.form = {
          mode: this.config.mode,
          retriesToAllowSend: this.config.retriesToAllowSend,
        };
      }
    },
    closeModal() {
      this.$emit('close');
    },
    save() {
      const hasRetries =
        this.form.retriesToAllowSend !== null &&
        this.form.retriesToAllowSend !== '';

      this.$emit('save', {
        mode: this.form.mode,
        retriesToAllowSend: hasRetries
          ? Number(this.form.retriesToAllowSend)
          : null,
      });
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.open();
        }
      },
    },
  },
};
</script>
<style scoped>
.label-text {
  font-size: 12px;
  font-weight: 200;
  color: #333;
}

.mode-select.activeOptions ::v-deep .input-select {
  transform: none;
}
</style>
